import { Injectable } from '@angular/core';
import {HttpService} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactService extends HttpService{

    postContactForm(data: any): Observable<any> {
        return this.post('contact', data).pipe(
            map((response: any) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
